import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { icons } from '@shared/static/icons';
import { useMoreMenuDialog } from '@utils/dialogs-hooks';
import { userTopMenu } from '@utils/userMenu';
import SidebarLink from './SidebarLink';

export default function SidebarBottom() {
  const { user } = useSelector((state) => state.user);
  const { openMoreMenuDialog } = useMoreMenuDialog();
  const { t } = useTranslation();
  return (
    <div className="sidebar-bottom">
      <div className="sidebar-bottom__links">
        {userTopMenu
          .filter(
            (item) =>
              !item.exclude?.includes(user.group_role) &&
              item.path !== '/balances',
          )
          .map((item) => (
            <SidebarLink key={item.text} item={item} />
          ))}
        <div className="sidebar__menu-item" onClick={openMoreMenuDialog}>
          {icons['sidebar-more']}
          <span>{t('more')}</span>
        </div>
      </div>
    </div>
  );
}
